import React, { Component } from "react";

import CategoriesEditForm from "./categoriesEditFront";
import CategoriesEditFunc from "./categoriesEditFunc";

import { withRouter } from "react-router-dom";
import * as ROUTES from "../../../../constants/routes";

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import Helpers from "../../../Helpers";

const INITIAL_STATE = {
  funds: [],
  categoryCode: "",
  categoryTitle: "",
  choosenFunds: [],
  categoryDescription: "",
  categoryOrder: "",
  categoryIcon: [],
  categoryCodeError: "",
  categoryTitleError: "",
  choosenFundsError: "",
  categoryIconError: "",
  fileName: "",
  iconPreview: "",
  existingIconUrl: "",
  fundsSelected: [],
  isLoading: false,
  toggleAlert: false,
  messageType: "warning",
  messageAlert: "",
  toggleActionAlert: false,
};

class CategoriesEditFormBase extends Component {
  constructor(props) {
    super(props);

    this.helpers = new Helpers();
    this.state = { ...INITIAL_STATE };
    this.categoriesEditFunction = new CategoriesEditFunc();
    this.db = firebase.firestore();
    this.storage = firebase.storage().ref();
    this.fundCatRef = this.db.collection("fundCategories");
  }

  componentDidMount() {
    var catId = this.props.location.state.id;

    this.fundCatRef
      .doc(catId)
      .get()
      .then(async (doc) => {
        if (doc.exists) {
          const categoryData = doc.data();
          let catDesc = this.helpers.stringToWhiteSpaceConverter(
            categoryData.description
          );
          
          let iconUrl = "";
          if (categoryData.icon) {
            try {
              iconUrl = await this.storage.child(categoryData.icon).getDownloadURL();
            } catch (err) {
              console.log("Error fetching icon URL:", err);
            }
          }
          
          this.setState({
            categoryCode: categoryData.code,
            categoryTitle: categoryData.name,
            categoryDescription: catDesc,
            categoryOrder: categoryData.order !== undefined && categoryData.order !== null ? String(categoryData.order) : "",
            existingIconUrl: iconUrl,
            fileName: categoryData.icon ? this.getFileNameFromUrl(categoryData.icon) : "",
          });
        } else {
          this.setState({
            toggleActionAlert: true,
            messageType: "error",
            messageAlert: "Document doesn't exists.",
          });
        }
      })
      .catch((error) => {
        this.setState({
          toggleActionAlert: true,
          messageType: "error",
          messageAlert: error.message,
        });
      });
  }

  getFileNameFromUrl(url) {
    if (!url) return "";
    try {
      const decodedUrl = decodeURIComponent(url);
      const parts = decodedUrl.split("/");
      const lastPart = parts[parts.length - 1];
      return lastPart.split("?")[0];
    } catch {
      return "Current icon";
    }
  }

  handleInputChange = async (event) => {
    if (event.target.name === "categoryIcon") {
      const file = event.target.files;

      if (file.length > 0) {
        var dimension = await this.getImageDimension(file);

        if (dimension.width > 1000 || dimension.height > 1000) {
          this.setState({
            categoryIcon: [],
            fileName: "",
            iconPreview: "",
            categoryIconError: "File exceeds the maximum size (1000x1000px)",
          });
          event.target.value = null;
        } else if (dimension.width < 50 && dimension.height < 50) {
          this.setState({
            categoryIcon: [],
            fileName: "",
            iconPreview: "",
            categoryIconError: "File does not meet the minimum size (50x50px)",
          });
          event.target.value = null;
        } else {
          const previewUrl = URL.createObjectURL(file[0]);
          this.setState({
            categoryIcon: file,
            fileName: file[0].name,
            iconPreview: previewUrl,
            existingIconUrl: "",
            categoryIconError: "",
          });
        }
      } else {
        this.setState({
          categoryIcon: [],
          fileName: "",
          iconPreview: "",
          categoryIconError: "",
        });
      }
    } else {
      const name = event.target.name;
      this.setState({ [event.target.name]: event.target.value }, () => {
        this.validator(name);
      });
    }
  };

  getImageDimension(file) {
    const dimension = [];
    var _URL = window.URL || window.webkitURL;
    var img;

    var promise = new Promise((resolve, reject) => {
      img = new Image();
      img.onload = function () {
        dimension.push({ width: this.width, height: this.height });
        resolve(dimension[0]);
      };
      img.onerror = function (err) {
        reject(err.message);
      };
      img.src = _URL.createObjectURL(file[0]);
    });

    return promise;
  }

  validator = (name) => {
    const { categoryCode, categoryTitle } = this.state;

    switch (name) {
      case "categoryCode":
        if (categoryCode.trim() === "") {
          this.setState({ categoryCodeError: "Please input category code." });
        } else {
          this.setState({ categoryCodeError: "" });
        }
        break;
      case "categoryTitle":
        if (categoryTitle.trim() === "") {
          this.setState({ categoryTitleError: "Please input category title." });
        } else {
          this.setState({ categoryTitleError: "" });
        }
        break;
      default:
        break;
    }
  };

  onSubmit = (event) => {
    event.preventDefault();
    var categoryId = this.props.location.state.id;

    this.setState({ isLoading: true });

    const {
      categoryCode,
      categoryTitle,
      categoryDescription,
      categoryOrder,
      categoryIcon,
      categoryCodeError,
      categoryTitleError,
      categoryIconError,
    } = this.state;

    const isValid = categoryCodeError === "" && categoryTitleError === "" && categoryIconError === "";

    if (isValid) {
      this.categoriesEditFunction
        .doCategoryEdit(
          categoryId,
          categoryCode,
          categoryTitle,
          categoryDescription,
          categoryOrder,
          categoryIcon
        )
        .then(() => {
          this.setState({
            isLoading: false,
            toggleActionAlert: true,
            messageType: "success",
            messageAlert: "Category edited successfully.",
          });

          setTimeout(() => {
            this.props.history.push(ROUTES.CATEGORIES_LIST);
          }, 1000);
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
            toggleActionAlert: true,
            messageType: "error",
            messageAlert: error.message,
          });
        });
    } else {
      this.setState({
        isLoading: false,
        toggleActionAlert: true,
        messageType: "error",
        messageAlert: "An error occured.",
      });
    }
  };

  onhandleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ toggleActionAlert: false });
  };

  render() {
    return (
      <CategoriesEditForm
        state={this.state}
        onChange={() => this.handleInputChange.bind(this)}
        onSubmit={() => this.onSubmit.bind(this)}
        onhandleClose={() => this.onhandleClose.bind(this)}
      />
    );
  }
}

export default withRouter(CategoriesEditFormBase);
